import { Form, InputNumber } from "antd";
import fieldDataTypes from "common/data/fieldDataTypes";
import CypressTestIds from "../../../cypress/CypressTestIds";

export default ({ selectedFieldRow, dataType, readOnly, getFormErrors }) => {
    return (
        <Form.Item
            label="Min Length"
            name={["fields", selectedFieldRow.name, "min"]}
            initialValue={fieldDataTypes[dataType].min}
            rules={[
                // Disallow zero when field is required
                ({ getFieldValue, ...param }) => ({
                    validator(_, value) {
                        const isRequired = getFieldValue(["fields", selectedFieldRow.name, "isRequired"]);
                        if (isRequired && value === 0) {
                            return Promise.reject(new Error("Min Length cannot be 0 for required fields."));
                        }
                        return Promise.resolve();
                    },
                }),
                ({ getFieldValue, ...param }) => ({
                    validator(_, value) {
                        if (value <= getFieldValue(["fields", selectedFieldRow.name, "max"])) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error("Min Length should be less than or equal to Max Length."));
                    },
                }),
            ]}
            {...getFormErrors(`fields.${selectedFieldRow.name}.min`)}
        >
            <InputNumber
                data-testid={CypressTestIds.SCHEMA_MIN_LENGTH_PROPERTY_INPUT}
                type="number"
                readOnly={readOnly}
                // Allow 0 when field is not required; validators will block 0 when required
                min={0}
                max={fieldDataTypes[dataType].max}
            ></InputNumber>
        </Form.Item>
    );
};
